export const demoUsers = [
  { name: "Yavan Columbus", id: "yavan", role: "participant", roleName: "participant" },
  { name: "Fern Magellan", id: "fern", role: "participant", roleName: "participant" },
  { name: "Fabio Ulysses", id: "fabio", role: "participant", roleName: "participant" },
  { name: "Tristan Mariner", id: "tristan", role: "participant", roleName: "participant" },
  { name: "Patrick Neptune", id: "patrick", role: "participant", roleName: "participant" },
  { name: "Regina O'Malley", id: "regina", role: "participant", roleName: "participant" },
  { name: "Lisa Baret", id: "lisa", role: "participant", roleName: "participant" }
];

const demoData = {
  mtDemo: {
    task6: {
      predefinedDemoStrengths: {
        en: [
          "Empathetic",
          "Precise",
          "Compassionate",
          "Analytical",
          "Practical",
          "Determined",
          "Empathetic",
          "Persevering",
          "Determined",
          "Independent",
          "Analytical",
          "Determined",
          "Empathetic",
          "Creative",
          "Imaginative",
          "Empathetic",
          "Compassionate",
          "Realistic",
          "Analytical",
          "Logical",
          "Pragmatic"
        ],
        fr: [
          "Empathique",
          "Précis(e)",
          "Compatissant(e)",
          "Analytique",
          "Pratique",
          "Déterminé(e)",
          "Empathique",
          "Persévérant(e)",
          "Déterminé(e)",
          "Indépendant(e)",
          "Analytique",
          "Déterminé(e)",
          "Empathique",
          "Créatif(ive)",
          "Imaginatif(ive)",
          "Empathique",
          "Compatissant(e)",
          "Réaliste",
          "Analytique",
          "Logique",
          "Pragmatique"
        ],
        de: [
          "Empathisch",
          "Präzise",
          "Mitfühlend",
          "Analytisch",
          "Praktisch",
          "Zielstrebig",
          "Empathisch",
          "Ausdauernd",
          "Zielstrebig",
          "Unabhängig",
          "Analytisch",
          "Zielstrebig",
          "Empathisch",
          "Kreativ",
          "Fantasievoll",
          "Empathisch",
          "Mitfühlend",
          "Realistisch",
          "Analytisch",
          "Logisch",
          "Pragmatisch"
        ]
      },
      strengthsSubmissions: {
        yavan: ["Empathetic", "Precise", "Compassionate"],
        fern: ["Empathetic", "Creative", "Imaginative"],
        fabio: ["Analytical", "Practical", "Determined"],
        tristan: ["Independent", "Analytical", "Determined"],
        patrick: ["Empathetic", "Persevering", "Determined"],
        regina: ["Empathetic", "Compassionate", "Realistic"],
        lisa: ["Analytical", "Logical", "Pragmatic"]
      }
    },
    startPositions: {
      a: {
        0: {
          optionTwo: [],
          optionThree: [
            {
              ...demoUsers[2],
              type: "a"
            }
          ],
          optionFour: [
            {
              ...demoUsers[2],
              type: "a"
            },
            {
              ...demoUsers[6],
              type: "a"
            }
          ]
        },
        1: {
          optionTwo: [
            {
              ...demoUsers[0],
              type: "a"
            },
            {
              ...demoUsers[4],
              type: "a"
            },
            {
              ...demoUsers[5],
              type: "a"
            }
          ],
          optionThree: [
            {
              ...demoUsers[0],
              type: "a"
            },
            {
              ...demoUsers[4],
              type: "a"
            },
            {
              ...demoUsers[1],
              type: "a"
            }
          ]
        },
        2: {
          optionTwo: [],
          optionThree: [
            {
              ...demoUsers[3],
              type: "a"
            },
            {
              ...demoUsers[6],
              type: "a"
            }
          ],
          optionFour: [
            {
              ...demoUsers[3],
              type: "a"
            }
          ]
        },
        3: {
          optionTwo: [
            {
              ...demoUsers[1],
              type: "a"
            }
          ],
          optionThree: [],
          optionFour: [
            {
              ...demoUsers[5],
              type: "a"
            }
          ]
        }
      },
      b: {
        0: {
          optionOne: [],
          optionTwo: [],
          optionThree: [
            {
              ...demoUsers[0],
              type: "b"
            },
            {
              ...demoUsers[1],
              type: "b"
            },
            {
              ...demoUsers[4],
              type: "b"
            },
            {
              ...demoUsers[5],
              type: "b"
            }
          ],
          optionFour: [
            {
              ...demoUsers[0],
              type: "b"
            },
            {
              ...demoUsers[1],
              type: "b"
            }
          ]
        },
        1: {
          optionOne: [
            {
              ...demoUsers[6],
              type: "b"
            }
          ],
          optionTwo: [],
          optionThree: [],
          optionFour: [
            {
              ...demoUsers[3],
              type: "b"
            }
          ]
        },
        2: {
          optionOne: [
            {
              ...demoUsers[5],
              type: "b"
            }
          ],
          optionTwo: [],
          optionThree: [
            {
              ...demoUsers[4],
              type: "b"
            }
          ],
          optionFour: []
        },
        3: {
          optionOne: [],
          optionTwo: [],
          optionThree: [
            {
              ...demoUsers[2],
              type: "b"
            },
            {
              ...demoUsers[6],
              type: "b"
            }
          ],
          optionFour: [
            {
              ...demoUsers[2],
              type: "b"
            },
            {
              ...demoUsers[3],
              type: "b"
            }
          ]
        }
      }
    },
    demoUsers: demoUsers
  },
  mtOnlineDemo: {
    task6: {
      predefinedDemoStrengths: {
        en: [
          "Empathetic",
          "Precise",
          "Compassionate",
          "Analytical",
          "Practical",
          "Determined",
          "Empathetic",
          "Persevering",
          "Determined",
          "Independent",
          "Analytical",
          "Determined",
          "Empathetic",
          "Creative",
          "Imaginative",
          "Empathetic",
          "Compassionate",
          "Realistic",
          "Analytical",
          "Logical",
          "Pragmatic"
        ],
        fr: [
          "Empathique",
          "Précis(e)",
          "Compatissant(e)",
          "Analytique",
          "Pratique",
          "Déterminé(e)",
          "Empathique",
          "Persévérant(e)",
          "Déterminé(e)",
          "Indépendant(e)",
          "Analytique",
          "Déterminé(e)",
          "Empathique",
          "Créatif(ive)",
          "Imaginatif(ive)",
          "Empathique",
          "Compatissant(e)",
          "Réaliste",
          "Analytique",
          "Logique",
          "Pragmatique"
        ],
        de: [
          "Empathisch",
          "Präzise",
          "Mitfühlend",
          "Analytisch",
          "Praktisch",
          "Zielstrebig",
          "Empathisch",
          "Ausdauernd",
          "Zielstrebig",
          "Unabhängig",
          "Analytisch",
          "Zielstrebig",
          "Empathisch",
          "Kreativ",
          "Fantasievoll",
          "Empathisch",
          "Mitfühlend",
          "Realistisch",
          "Analytisch",
          "Logisch",
          "Pragmatisch"
        ]
      },
      strengthsSubmissions: {
        yavan: ["Empathetic", "Precise", "Compassionate"],
        fern: ["Empathetic", "Creative", "Imaginative"],
        fabio: ["Analytical", "Practical", "Determined"],
        tristan: ["Independent", "Analytical", "Determined"],
        patrick: ["Empathetic", "Persevering", "Determined"],
        regina: ["Empathetic", "Compassionate", "Realistic"],
        lisa: ["Analytical", "Logical", "Pragmatic"]
      }
    },
    startPositions: {
      a: {
        0: {
          optionTwo: [],
          optionThree: [
            {
              ...demoUsers[2],
              type: "a"
            }
          ],
          optionFour: [
            {
              ...demoUsers[2],
              type: "a"
            },
            {
              ...demoUsers[6],
              type: "a"
            }
          ]
        },
        1: {
          optionTwo: [
            {
              ...demoUsers[0],
              type: "a"
            },
            {
              ...demoUsers[4],
              type: "a"
            },
            {
              ...demoUsers[5],
              type: "a"
            }
          ],
          optionThree: [
            {
              ...demoUsers[0],
              type: "a"
            },
            {
              ...demoUsers[4],
              type: "a"
            },
            {
              ...demoUsers[1],
              type: "a"
            }
          ]
        },
        2: {
          optionTwo: [],
          optionThree: [
            {
              ...demoUsers[3],
              type: "a"
            },
            {
              ...demoUsers[6],
              type: "a"
            }
          ],
          optionFour: [
            {
              ...demoUsers[3],
              type: "a"
            }
          ]
        },
        3: {
          optionTwo: [
            {
              ...demoUsers[1],
              type: "a"
            }
          ],
          optionThree: [],
          optionFour: [
            {
              ...demoUsers[5],
              type: "a"
            }
          ]
        }
      },
      b: {
        0: {
          optionOne: [],
          optionTwo: [],
          optionThree: [
            {
              ...demoUsers[0],
              type: "b"
            },
            {
              ...demoUsers[1],
              type: "b"
            },
            {
              ...demoUsers[4],
              type: "b"
            },
            {
              ...demoUsers[5],
              type: "b"
            }
          ],
          optionFour: [
            {
              ...demoUsers[0],
              type: "b"
            },
            {
              ...demoUsers[1],
              type: "b"
            }
          ]
        },
        1: {
          optionOne: [
            {
              ...demoUsers[6],
              type: "b"
            }
          ],
          optionTwo: [],
          optionThree: [],
          optionFour: [
            {
              ...demoUsers[3],
              type: "b"
            }
          ]
        },
        2: {
          optionOne: [
            {
              ...demoUsers[5],
              type: "b"
            }
          ],
          optionTwo: [],
          optionThree: [
            {
              ...demoUsers[4],
              type: "b"
            }
          ],
          optionFour: []
        },
        3: {
          optionOne: [],
          optionTwo: [],
          optionThree: [
            {
              ...demoUsers[2],
              type: "b"
            },
            {
              ...demoUsers[6],
              type: "b"
            }
          ],
          optionFour: [
            {
              ...demoUsers[2],
              type: "b"
            },
            {
              ...demoUsers[3],
              type: "b"
            }
          ]
        }
      }
    },
    demoUsers: demoUsers
  }
};

export default demoData;
